import { kit } from './strings'
import './PageLoader.css'

/**
 * The whole page is waiting.
 *
 * `LoadingState` is a PANEL's busy state — it sits inside a card whose title and
 * frame are already on screen. Opening a page is a different moment: there is
 * nothing on screen yet, so the loader holds the middle of the column with one
 * ring and the line that says what is happening.
 *
 * One mark (general-style pass, 2026-10): it used to be two arcs turning against
 * each other, a breathing disc and a shuttle bar — three motions for one fact.
 *
 * `full` is for the one case where the loader IS the document: a route whose
 * whole shell is still being fetched, so there is no header, rail or column to
 * sit in.
 *
 * @param {{label?: string, full?: boolean}} props
 */
export default function PageLoader({ label = kit.loading, full = false }) {
  return (
    <div
      className={`page-loader${full ? ' page-loader--full' : ''}`}
      data-testid="page-loader"
      role="status"
      aria-busy="true"
      aria-live="polite"
    >
      <span className="page-loader__ring" aria-hidden="true" />

      <p className="page-loader__label">
        <bdi>{label}</bdi>
      </p>
    </div>
  )
}
